import { parseBooleanValue } from "../../util";
import { IIndexAttributeData } from "../model/IndexAttributeData";

const IndexAttributeDataParamMapper = (item: IIndexAttributeData) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid)
  };
};

export default IndexAttributeDataParamMapper;
